var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heatmap-cell p-1",style:(_vm.cellStyle)},[_c('b-col',[_c('div',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.value.count)+" ")])]),_c('b-tooltip',{attrs:{"target":_vm.cellID,"triggers":"hover","variant":"light","placement":"top"}},[_vm._v(" "+_vm._s(_vm.calculateTooltipBPS(_vm.value))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }